import React, { useCallback, useEffect, useState } from 'react';
interface FormState {
    load: boolean;
    recaptchaLoaded: boolean;
    formErrors: Record<string, string[]>;
    captchaValue: string | null;
}

interface FormProps {
    onSubmit?: (formData: FormState) => void;
    children: React.ReactNode;
}

const BaseFormContainer: React.FC<FormProps> = ({
                                       onSubmit,
                                       children
}) => {
    const [state, setState] = useState<FormState>({
        load: false,
        recaptchaLoaded: false,
        formErrors: {},
        captchaValue: null,
    });

    const _asyncScriptOnLoad = () => {
        setState((prevState) => ({ ...prevState, recaptchaLoaded: true }));
    };

    const _getError = (fieldName: string): string | null => {
        const errors = state.formErrors[fieldName];
        return errors && errors.length > 0 ? errors[0] : null;
    };

    const _onCaptchaChange = (val: string | null) => {
        if (val !== null) {
            setState((prevState) => ({ ...prevState, captchaValue: val }));
        }
    };

    const submitForm = useCallback(() => {
        if (onSubmit) {
            onSubmit(state);
        }
    }, [onSubmit, state]);

    useEffect(() => {
        if (state.captchaValue !== null) {
            submitForm();
        }
    }, [state.captchaValue, submitForm]);

    return (
        <form onSubmit={(e) => e.preventDefault()}>
            {children}
        </form>
    );
};

export default BaseFormContainer;